import React from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {PuiButton} from "@portnet/ui";
import GetAppIcon from '@mui/icons-material/GetApp';
function ExportExcel(props) {
  const { ExcelData, fileName } = props;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = (rows, fileName) => {
    let ExcelData = [] ;
    rows.forEach(function (row) {
        ExcelData.push({
            "Port":row.port,
            "N° Conteneur":row.idEquipment,
            "N° voyage":row.idPortCall,
            "Voyage":row.portcall,
            "Entrant / Sortant":row.inbound == "O" ? "Sortant" : "Entrant",
            "Vide":row.empty,
            "Transporteur":"",
            "Type équipement":row.typeOfEquipment,
            "N° Réservation":"",
            "Poids Brut":row.grossWeight,
            "Poids Net":row.netWeight,
            "Marchandises dangereuses":row.dangerousGoods,
            "Transbordement":"",
            "Statut douanier":"",
            "Date main levée":"",
            "Date entrée au terminal":row.gateInDateTime,
            "Date sortie du terminal":row.gateOutDateTime,
            "Date chargement":row.loadedDateTime,
            "Date déchargement":row.dischargedDateTime,
            "Date livraison vide":row.emptyDeliveredDateTime,
            "Type de transport d'entrée":row.inboundMeansOfTransportType,
            "Nom du transport d'entrée":row.inboundMeansOfTransportName,
            "Type de transport de sortie":row.outboundMeansOfTransportType,
            "Nom du transport de sortie":row.outboundMeansOfTransportName,
            "Nom opérateur du terminal":row.terminalOperatorName,
            "N° Connaissement":row.blNumber});
    })
    console.log('ExcelData' + ExcelData);
    let header = [
      "Version",
      "Port",
      "N° Conteneur",
      "N° voyage",
      "Voyage",
      "Entrant / Sortant",
      "Vide",
      "Transporteur",
      "Type équipement",
      "N° Réservation",
      "Poids Brut",
      "Poids Net",
      "Marchandises dangereuses",
      "Transbordement",
      "Statut douanier",
      "Date main levée",
      "Date entrée au terminal",
      "Date sortie du terminal",
      "Date chargement",
      "Date déchargement",
      "Date livraison vide",
      "Type de transport d'entrée",
      "Nom du transport d'entrée",
      "Type de transport de sortie",
      "Nom du transport de sortie",
      "Nom opérateur du terminal",
      "Abonné",
      "N° Connaissement",
    ];

    var wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(ExcelData);
  //  XLSX.utils.sheet_add_aoa(ws, [header]);
    XLSX.utils.book_append_sheet(wb, ws);

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
      <PuiButton
          onClick={(e) => exportToExcel(ExcelData, fileName)}
          color="tertiary"
          startIcon={<GetAppIcon />}
      >Exporter</PuiButton>

  );
}

export default ExportExcel;
